import styled from 'styled-components/macro';

import { Box } from '@olist/united';

import { StepContent as StepContentItem } from '../../../components';

export const StepPanel = styled(Box)`
  animation: slide-in-top 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  max-width: 436px;

  width: 100%;

  @keyframes slide-in-top {
    0% {
      transform: translateY(-80px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const StepContent = styled(Box)`
  ${StepContentItem} {
    animation: slide-in-left 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;

    @keyframes slide-in-left {
      0% {
        transform: translateX(-80px);
        opacity: 0;
      }
      100% {
        transform: translateX(0);
        opacity: 1;
      }
    }
  }
`;
